/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ContentFactory
 * @hideconstructor
 * @classdesc API class that is used to generate content specs and create them
 */
define([
	'../../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../../../canvas/PageContent',
	'../../../../../lib/@waca/dashboard-common/dist/api/ContentProviderAPI',
	'./BaseContentProvider'
], (APIFactory, PageContent, ContentProviderAPI, BaseContentProvider) => {
	const TEMPLATE_PATH = 'text!dashboard/layout/templates/';

	class PageContentProvider extends BaseContentProvider {

		constructor(options) {
			super(options);
		}

		getAPI() {
			return APIFactory.createAPI(this, [ContentProviderAPI]);
		}

		getTypeList() {
			return ['page', 'container'];
		}

		addModel(options, { canvasContent }) {
			return new Promise((resolve, reject) => {
				try {
					const templateName = options.properties.templateName || 'Template1';
					delete options.properties.templateName;
					require([TEMPLATE_PATH + templateName + '.json'], (Template) => {
						options.spec = options.spec || JSON.parse(Template);
						options.containerId = options.containerId || canvasContent.getId();
						super.addModel(...arguments).then((id) => {
							resolve(id);
						});
					}, reject);
				} catch(error) {
					reject(error);
				}
			});
		}

		createContent(options) {
			return new PageContent(options);
		}
	}
	return PageContentProvider;
});
